import type { TFunction } from 'i18next';

/** Scadenze tecniche: la pagina e il pannello di una verifica. */
export const MACHINE_CHECKS_ROUTE = '/protected/machine-checks';

export const machineCheckSheetRoute = (id: string) =>
  `${MACHINE_CHECKS_ROUTE}/checks/${id}`;

/** Sezioni della pagina, nel parametro `view` (default: scadenzario). */
export const MACHINE_CHECKS_VIEWS = {
  PLANS: 'plans',
  CHECKS: 'checks',
  FINDINGS: 'findings',
} as const;

export type MachineChecksView =
  (typeof MACHINE_CHECKS_VIEWS)[keyof typeof MACHINE_CHECKS_VIEWS];

const VIEW_VALUES: readonly string[] = Object.values(MACHINE_CHECKS_VIEWS);

export function resolveMachineChecksView(value: unknown): MachineChecksView {
  return VIEW_VALUES.includes(value as string)
    ? (value as MachineChecksView)
    : MACHINE_CHECKS_VIEWS.PLANS;
}

/** Parametri di una sezione che non valgono nelle altre. */
export const VIEW_RESET_PARAMS = {
  tab: undefined,
  search: undefined,
  sort: undefined,
  outcomes: undefined,
  skip: undefined,
  take: undefined,
} as const;

/**
 * Tab di sezione della testata: il totale delle anomalie aperte sta sulla
 * sezione «Anomalie» (gli stati delle scadenze sono già i tab della tabella).
 */
export function buildMachineChecksViewTabs(
  translate: TFunction,
  openFindings: number | undefined
) {
  return Object.values(MACHINE_CHECKS_VIEWS).map((value) => ({
    value,
    text: translate(`machine_checks.views.${value}`),
    ...(value === MACHINE_CHECKS_VIEWS.FINDINGS ? { count: openFindings } : {}),
  }));
}
